module.exports = __webpack_public_path__ + "img/guards.d3ac778c.jpg";